import _ from "lodash";
import React from "react";
import { colors } from "Constants";
import I18nHOC from "UIComponents/I18nHOC";
import {
  TAGGABLE_PROJECT_ELEMENTS,
  PROJECT_TEMPLATE_FIELD_OBJECTS,
} from "ProcessJournal/modules/Module";
import classes from "./ProjectElementTag.scss";
import FieldComponent from "UnitPlans/components/IBcomponents/FieldComponent";
import { getPYPElementSetFromNodes, generateNestedSelectedData } from "Utils";
import { connect } from "react-redux";
import { getCurrentProjectGroupDetails } from "Projects/modules/ProjectModules";
import { compose } from "lib/apolloClient";
import {
  TEMPLATE_FIELD_SERVICE_ACTION_OUTCOMES_MYP,
  TEMPLATE_FIELD_CAS_LEARNING_OUTCOMES_DP,
} from "Constants/stringConstants";
import { getIsTypeOfProjectPortfolioLOs } from "Projects/modules/Utils";
import { AddCircleOutlined, PencilLineOutlined } from "@toddle-edu/ds-icons";

const dividerStyle = `8px solid ${colors.toddleBG1}`;

const TagType = props => {
  const { title, dataLength, onAddOrEditClick } = props;

  return (
    <div className={classes.tagTypeContainer} onClick={onAddOrEditClick}>
      <div className={classes.tagTypeText}>{title}</div>
      <div className={classes.tagIconContainer}>
        {dataLength == 0 ? (
          <AddCircleOutlined variant={"link"} size={"xx-small"} />
        ) : (
          <PencilLineOutlined variant={"link"} size={"xx-small"} />
        )}
      </div>
    </div>
  );
};

const getLabelFromNodes = ({ nodes, value }) => {
  return _.map(
    _.filter(nodes, node => _.includes(value, node.id)),
    item => {
      const { label, type } = item;
      const displayName = _.get(item, ["metadata", "display_name"], null);

      return getIsTypeOfProjectPortfolioLOs({ type }) &&
        displayName &&
        !_.includes(label, displayName)
        ? `${displayName}: ${label}`
        : label;
    }
  );
};

const renderProjectTagOptions = ({
  projectTagOptions,
  t,
  elementPYP,
  onAddOrEditClick,
}) => {
  return (
    <div className={classes.projectTagOptions}>
      {_.map(projectTagOptions, (element, index) => {
        const fieldObj = PROJECT_TEMPLATE_FIELD_OBJECTS[element.value];

        const fieldData = _.find(elementPYP, {
          fieldUID: element.value,
        });

        const startDepth = _.get(
          fieldObj,
          "config.fieldTypeConfig.rootNodeDepth",
          0
        );

        let value;
        switch (element.value) {
          case TEMPLATE_FIELD_SERVICE_ACTION_OUTCOMES_MYP:
          case TEMPLATE_FIELD_CAS_LEARNING_OUTCOMES_DP:
            value = getLabelFromNodes({
              nodes: _.get(fieldData, "resolvedMinimalTree.nodes", []),
              value: _.get(fieldData, "value", []),
            });
            break;
          default:
            value = generateNestedSelectedData({
              ...getPYPElementSetFromNodes({
                startDepth,
                nodes: _.get(fieldData, "resolvedMinimalTree.nodes", []),
              }),
              value: _.get(fieldData, "value", []),
            });
            break;
        }

        const dataLength = _.size(_.get(fieldData, "value", []));

        const isFirst = index == 0;
        const isLast = index == _.size(TAGGABLE_PROJECT_ELEMENTS) - 1;

        return (
          <div
            key={element.value}
            className={classes.tagDetailsContainer}
            style={{
              borderTop: isFirst ? dividerStyle : "none",
              borderBottom: !isLast ? dividerStyle : "none",
            }}
          >
            <TagType
              title={t(element.tagLabel)}
              dataLength={dataLength}
              onAddOrEditClick={() => onAddOrEditClick(element.value)}
            />
            {dataLength > 0 && (
              <FieldComponent
                mode={"view"}
                value={value}
                type={fieldObj.viewType}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

const ProjectElementTag = props => {
  const { projectGroupType, t, elementPYP, onAddOrEditClick } = props;

  const projectTagOptions = _.filter(TAGGABLE_PROJECT_ELEMENTS, item =>
    _.includes(item.projectType, projectGroupType)
  );

  return _.size(projectTagOptions) != 0
    ? renderProjectTagOptions({
        projectTagOptions,
        t,
        elementPYP,
        onAddOrEditClick,
      })
    : null;
};

const mapStateToProps = state => {
  const { type: projectGroupType } = getCurrentProjectGroupDetails({
    state,
  });
  return {
    projectGroupType,
  };
};

export default compose(
  I18nHOC({ resource: ["common", "journal"] }),
  connect(mapStateToProps)
)(ProjectElementTag);
